module.exports = __webpack_public_path__ + "media/vraag_4_vraag.e2e0b809.mp3";